import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "target-segment-service/target-segment";

export default {
    createTargetSegment(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/create", param, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getTargetSegments(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/list/" + param.page, param.payload, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getTargetSegmentCount(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/count", param.payload, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getSearchableFields() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/searchable-fields", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    // getBranches() {
    //     return new Promise(() => {
    //         //TODO Get Branches from Organization Service
    //         return null;
    //     });
    // },
    visibility(param, uuid) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/update/visibility/" + uuid, param, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    //console.log(param);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    delete(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(BASE_SERVICE_URL + "/delete/" + uuid, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    //console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    view(uuid) {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/view/" + uuid, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    //console.log(response);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updateTargetSegment(param, uuid) {
        console.log(uuid);
        console.log(param);
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/update/" + uuid, param, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    //console.log(param);
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    }
};
